import React, { Fragment } from 'react';

import ClubRegistrationConstants from '../utils/ClubRegistrationConstants';

import ClubOwnerTypeDropdown from '../../../components/dropdowns/ClubOwnerTypeDropdown';
import BusinessEntityDropdown from '../../../components/dropdowns/BusinessEntityDropdown';
import OfferingTypeRegistrationRadiobuttonList from '../../../components/radiobuttonlists/OfferingTypeRegistrationRadiobuttonList';

import Input from '@usas/ui-web/components/inputs/Input';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import LscDropdown from '@usas/ui-web/components/dropdowns/lscDropdown/LscDropdown';


import global from '@usas/ui-web/components/GlobalStyle.module.css';
import constants from '@usas/ui-web/utils/Constants';

const ClubRegistrationDisclaimerWrite = ({
  clubRegistrationState,
  handleSubmit,
  formState,
  errorState,
  onValueTextPairChanged,
  onFormValueChanged,
  clubOwnerTypeState,
  state,
  onBackClicked,
  filteredClubRegRequirementState,
  selectedLscMapState
}) => (

  <Fragment>
    <form onSubmit={handleSubmit} noValidate>
      <div className='row usas-extra-top-margin'>
        <div className='col-xs-12'>
          <span style={{ fontSize: '18px', color: '#202020', fontStyle: 'italic' }}>
            By beginning and completing this process, the applicant acknowledges that they will comply with all USA Swimming policies, code of conduct, rules, regulations, as well as federal, state, and local jurisdictions at all times.
          </span>
          <YesNoSwitch
            label=""
            name="isAcknowledged"
            checked={formState.isAcknowledged}
            error={errorState.isAcknowledged}
            message={errorState.isAcknowledged}
            onChange={(value) => { onFormValueChanged('isAcknowledged', value); }} />

        </div>
      </div>
      {formState.isAcknowledged === true &&
        <>
          <div className="row">
            <div className="col-xs-12">
              <h4>To register a new club, you will need the following information:</h4>
            </div>
          
            {formState.clubOwnerTypeId !== constants.DEFAULT_ID &&  
            <div className="col-xs-12">
              {filteredClubRegRequirementState.map((item, index) => {
                return (
                  <div key={index} className="row usas-extra-top-margin">
                    <div className="col-xs-12">
                      <li>
                        {item.description}
                      </li>
                    </div>
                  </div>
                )
              })}
            </div>
            }
          </div>
          <div className="row usas-extra-top-margin usas-extra-bottom-margin">
            <div className="col-xs-12 col-sm-6 col-md-4">
              <ClubOwnerTypeDropdown
                label="Owner Type*"
                name="clubOwnerTypeId"
                value={formState.clubOwnerTypeId}
                error={errorState.clubOwnerTypeId}
                message={errorState.clubOwnerTypeId}
                onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'clubOwnerTypeId', newValueLabel, 'ownerTypeName', e); }}
              />
            </div>
          </div>

          {formState.clubOwnerTypeId !== constants.DEFAULT_ID &&
          <div className="row usas-extra-top-margin usas-extra-bottom-margin">
            <div className="col-xs-12 col-sm-6 col-md-4">
              <YesNoSwitch
                  label="I have all required information ready"
                  name="isAllRequiredInfoReady"
                  checked={formState.isAllRequiredInfoReady}
                  error={errorState.isAllRequiredInfoReady}
                  message={errorState.isAllRequiredInfoReady}
                  onChange={(value) => { onFormValueChanged('isAllRequiredInfoReady', value); }} />
            </div>
          </div>
          }

          
          {formState.isAllRequiredInfoReady === true &&
          <>
          <div className="row usas-extra-top-margin usas-extra-bottom-margin">
            {clubOwnerTypeState.isLoaded === true ?
              <div className="col-xs-12 col-sm-6 col-md-4">
                <BusinessEntityDropdown
                  label="Tax Listing*"
                  name="businessEntityTypeId"
                  value={formState.businessEntityTypeId}
                  error={errorState.businessEntityTypeId}
                  message={errorState.businessEntityTypeId}
                  clubOwnerTypeId={formState.clubOwnerTypeId}
                  onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'businessEntityTypeId', newValueLabel, 'businessEntityTypeName', e); }}
                />
              </div>
              : <Fragment />}
            <div className={state.showNumOfBoardMembers === true && clubOwnerTypeState.isLoaded === true ? global.DisplayComponent : global.HideComponent}>
              <div className="col-xs-12 col-sm-6 col-md-4" >
                <Input
                  label="Number of Board Members*"
                  name="numOfBoardMembers"
                  value={formState.numOfBoardMembers}
                  error={errorState.numOfBoardMembers}
                  message={errorState.numOfBoardMembers}
                  onChange={(value) => { onFormValueChanged('numOfBoardMembers', value) }} />
              </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <LscDropdown
                label="LSC*"
                name="lscId"
                value={formState.lscId}
                error={errorState.lscId}
                message={errorState.lscId}
                onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'lscId', newValueLabel, 'lscName', e); }}
                isCurrent={true}
              />
            </div>
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12">
                {formState.lscId !== -1 && selectedLscMapState.selectedLscMap !== '' &&
                  <img width={'100%'} height={'650px'} src={`${import.meta.env.VITE_CDN_URL}/${selectedLscMapState.selectedLscMap}`} />
                }
              </div>
            </div>
            {formState.lscId !== -1 && formState.lscName !== 'Usa Swimming' &&
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12">
                <OfferingTypeRegistrationRadiobuttonList
                  label={"Select a Offering Type"}
                  name={"offeringInstanceId"}
                  error={errorState.offeringInstanceId}
                  message={errorState.offeringInstanceId}
                  value={formState.offeringInstanceId}
                  isVertical={true}
                  onChange={(value) => { onFormValueChanged('offeringInstanceId', parseInt(value)) }}
                  orgUnitId={formState.lscId}
                  isOrganizationRegistration={false}
                />
              </div>
            </div>
            }
          </div>
          {formState.lscId !== -1 &&
            <div className='row usas-extra-top-margin'>
              <div className='col-xs-12'>
                <span style={{ fontSize: '18px', color: '#202020', fontStyle: 'italic' }}>
                  The applicant acknowledges that the new club is located entirely within the boundaries of the selected LSC, or they have confirmed with USA Swimming’s staff that the club has otherwise met the criteria to be a club member of the LSC selected.
                </span>
                <YesNoSwitch
                  label=""
                  name="isCorrectLscSelected"
                  checked={formState.isCorrectLscSelected}
                  error={errorState.isCorrectLscSelected}
                  message={errorState.isCorrectLscSelected}
                  onChange={(value) => { onFormValueChanged('isCorrectLscSelected', value); }} />
              </div>
            </div>
          }
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
              {formState.isCorrectLscSelected &&
                <PrimaryButton type="submit">Continue</PrimaryButton>
              }&nbsp;
              {clubRegistrationState.objData?.status === ClubRegistrationConstants.IN_PROGRESS_STATUS ?
                <Fragment /> :
                <SecondaryButton type="button" onClick={() => onBackClicked()}>Back</SecondaryButton>}
            </div>
          </div>
          </>

        }


        </>
      }
    </form>
  </Fragment>
)

export default ClubRegistrationDisclaimerWrite;